<template>
  <b-modal
    ref="globalLocatorModal"
    size="xxl"
    :title="title"
    centered
    modal-class="global-locator-modal"
    :hide-footer="touchMode"
    qa="global-locator-modal"
    @cancel="cancel"
    @close="cancel"
  >
    <global-search-single-result
      v-if="singleResult"
      :laboratory-id="singleResult.laboratoryId"
      :entity-type="singleResult.entityType"
      :entity-value="singleResult.entityValue"
      :found-item="entityLabel"
      @hide="hide"
    />
    <global-search-multiple-result
      v-else
      :found-item="locatorInput"
      :result="result"
      @show-single-result="showSingleResult($event)"
      @hide="cancel"
    />
    <template #modal-footer>
      <global-search-single-result-footer
        v-if="singleResult"
        :entity="singleResult"
        :case-study-laboratory-id="caseStudyLaboratoryId"
        @navigate-to-registry-inbox="navigateToRegistryInbox($event)"
        @navigate-to-registry="navigateToRegistry($event)"
        @navigate-to-grossing="navigateToGrossing($event)"
        @navigate-to-laboratory="navigateToLaboratory($event)"
        @navigate-to-diagnosis="navigateToDiagnosis($event)"
        @navigate-to-viewer="navigateToViewer($event)"
        @hide="hide"
      />
      <global-search-multiple-result-footer
        v-else
        @hide="cancel"
      />
    </template>
  </b-modal>
</template>

<script>
import GlobalSearchSingleResult from './sections/GlobalSearchSingleResult'
import GlobalSearchSingleResultFooter from './sections/GlobalSearchSingleResultFooter'
import GlobalSearchMultipleResult from './sections/GlobalSearchMultipleResult'
import GlobalSearchMultipleResultFooter from './sections/GlobalSearchMultipleResultFooter'
import { IDENTIFIER_SCOPES } from '@/api/resources/identifierScopesResource'
import { BASE_URL } from '@/api/api'

export default {
    name: 'GlobalLocatorModal',
    components: {
        GlobalSearchSingleResult,
        GlobalSearchSingleResultFooter,
        GlobalSearchMultipleResult,
        GlobalSearchMultipleResultFooter
    },
    props: {
        touchMode: { type: Boolean, default: false }
    },
    data() {
        return {
            title: '',
            locatorInput: '',
            result: [],
            onOk: null,
            onCancel: null
        }
    },
    computed: {
        loggedLaboratoryId() {
            return this.$store.getters.labId
        },
        caseStudyLaboratoryId() {
            switch (this.singleResult.entityType) {
            case IDENTIFIER_SCOPES.REQUEST:
                return this.singleResult.entityValue.laboratory.labId
            case IDENTIFIER_SCOPES.CASE:
                return this.singleResult.entityValue.laboratory.labId
            case IDENTIFIER_SCOPES.SAMPLE:
                return this.singleResult.entityValue.caseStudy.laboratory.labId
            case IDENTIFIER_SCOPES.PORTION:
                return this.singleResult.entityValue.sample.caseStudy.laboratory.labId
            case IDENTIFIER_SCOPES.SUBPORTION:
                return this.singleResult.entityValue.portion.sample.caseStudy.laboratory.labId
            default: return this.loggedLaboratoryId
            }
        },
        singleResult() {
            return this.result?.length === 1
                ? this.result[0]
                : null
        },
        entityLabel() {
            if (!this.result) {
                return ''
            }
            const firstResult = this.result[0]
            switch (firstResult.entityType) {
            case IDENTIFIER_SCOPES.PERSON:
                return firstResult.entityValue.personIdentifier
            case IDENTIFIER_SCOPES.REQUEST:
                return firstResult.entityValue.label
            case IDENTIFIER_SCOPES.CASE:
                return firstResult.entityValue.casenumber
            case IDENTIFIER_SCOPES.SAMPLE:
                return firstResult.entityValue.sampleLabel
            case IDENTIFIER_SCOPES.PORTION:
                return firstResult.entityValue.portionLabel
            case IDENTIFIER_SCOPES.SUBPORTION:
                return firstResult.entityValue.subportionLabel
            default: return ''
            }
        }
    },
    methods: {
        showSingleResult(event) {
            if (this.onOk) {
                this.onOk(event)
                this.hide()
            } else {
                this.result = [ event ]
            }
        },
        show(title, locatorInput, result, onOk, onCancel) {
            this.title = title
            this.onOk = onOk
            this.onCancel = onCancel
            this.locatorInput = locatorInput
            this.result = result
            this.$nextTick(() => {
                this.$refs.globalLocatorModal.show()
            })
        },
        cancel() {
            if (this.onCancel) {
                this.onCancel()
            }
            this.hide()
        },
        hide() {
            this.$refs.globalLocatorModal.hide()
        },
        async navigateToRegistryInbox(entity) {
            this.$router.push({
                name: 'viewRequest',
                params: {
                    id: entity.requestId
                }
            })
            this.hide()
        },
        async navigateToRegistry(entity) {
            const navigationConfirmed = await this.$_confirmNavigationBecauseOfLaboratoryChange(entity.laboratoryId)
            if (navigationConfirmed) {
                this.$router.push({
                    name: 'registryEditCase',
                    params: Object.assign({
                        id: entity.caseId
                    }, entity.sampleId && { samId: entity.sampleId })
                })
                this.hide()
            }
        },
        async navigateToGrossing(entity) {
            this.$router.push({
                name: 'grossingSampleView',
                params: Object.assign({
                    casId: entity.caseId,
                    samId: entity.sampleId
                }, entity.portionId && { portionId: entity.portionId })
            })
            this.hide()
        },
        async navigateToLaboratory(entity) {
            const navigationConfirmed = await this.$_confirmNavigationBecauseOfLaboratoryChange(entity.laboratoryId)
            if (navigationConfirmed) {
                this.$router.push({
                    name: 'laboratorySampleView',
                    params: Object.assign({
                        casId: entity.caseId,
                        samId: entity.sampleId
                    }, entity.portionId && { portionId: entity.portionId })
                })
                this.hide()
            }
        },
        async navigateToDiagnosis(entity) {
            const navigationConfirmed = await this.$_confirmNavigationBecauseOfLaboratoryChange(entity.laboratoryId)
            if (navigationConfirmed) {
                this.$router.push({
                    name: 'diagnosisCaseInform',
                    params: Object.assign(
                        {
                            labId: entity.laboratoryId,
                            casId: entity.caseId
                        },
                        entity.sampleId && { samId: entity.sampleId },
                        entity.portionId && { porId: entity.portionId },
                        entity.subportionId && { subportionId: entity.subportionId }
                    )
                })
                this.hide()
            }
        },
        navigateToViewer(entity) {
            // TODO : revisar una vez que tengamos bien soportado en el back los adjuntos de escaneos
            const route = this.$router.resolve({
                name: 'viewerModule',
                query: {
                    imageType: 'WMTS',
                    imageWidth: 2000,
                    imageHeight: 1125,
                    imageUrl: `${BASE_URL}/viewer/laboratories/1/subportions/1/attachments/1/wmts`,
                    thumbnailUrl: `${BASE_URL}/viewer/laboratories/1/subportions/1/attachments/1/wmts/thumbnail`,
                    caseId: entity.caseId,
                    sampleId: entity.sampleId,
                    portionId: entity.portionId,
                    subportionId: entity.subportionId,
                    attachmentId: this.attachmentId,
                    userLastProfileImage: this.$store.getters.userLastProfileImage
                }
            })
            window.open(route.href, '_blank')
        }
    }
}
</script>

<style lang="scss">

.global-locator-modal .showtooltip{
  display: block !important;
  cursor: pointer;
}

.global-locator-modal .noshowtooltip{
  display: none !important;
}

.global-locator-modal .section-content .title{
    font-size: font-size(big);
    color: vt-color(primary);
}

.global-locator-modal .subtitle{
    color: vt-color(dark-text);
}

.global-locator-modal .no-gutters > .col{
  height: 100%;
}

.global-locator-modal .modal-body {
    border-radius: 0.5rem;
}

.global-locator-modal .vt-tabs .nav-tabs .nav-link,
.vt-tabs--small .nav-tabs .nav-link {
  font-size: font-size(very-small) !important;
}

.global-locator-modal .nav-pills {
  padding: 0 !important;
  background: vt-color(light-primary);
  height: 100% !important;
}

.global-locator-modal .nav-link.active {
  color: vt-color(primary);
  position: relative;
}

.global-locator-modal .nav-link.active .section-icon {
  opacity: 1;
}

.global-locator-modal .nav-link.active::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 100%;
  background: vt-color(primary);
  left: 0;
}

.global-locator-modal .inside-tab .nav-link.active::before {
  content: "";
  background: transparent;
}

.vt-tabs.inside-tab .nav-tabs .nav-link, .vt-tabs--small .nav-tabs .nav-link {
  border-bottom-color: transparent;
}

.global-locator-modal .nav-link {
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  border-bottom: 2px solid vt-color(white-light);
  width: 50px;
  font-size: font-size(big);
}

.global-locator-modal .section-content {
  height: calc(100vh - 300px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.global-locator-modal .tabs.row {
  border: 1px solid rgba(0, 0, 0, 0.125);
  height: 100%;
  position: relative;
}

.global-locator-modal .ag-root-wrapper-body.ag-layout-normal{
  padding: 0 !important;
}

@media (max-width: 1300px) {
  .global-locator-modal .section-content .title {
    font-size: font-size(normal);
    color: vt-color(primary);
  }
}
@media only screen and (max-width: 1366px) and (min-width: 1360px) {
  .global-locator-modal .section-content {
  height: calc(100vh - 240px) !important;
}
}
</style>

<style lang="scss" scoped>
.header i,
.header .title {
  font-size: font-size(big);
}

.header .title {
  color: vt-color(dark-text);
  font-weight: bold;
}
.section-indicator{
  position: absolute;
  width: auto;
  left: 23px;
  margin-top: 5px;
}
</style>
